import { Card } from "react-bootstrap";
import { Input, Row, Col, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";

import { productLists } from "data/product";
import Pagination from "components/Pagination";
import CardProduct from "components/Card/Product";

const WishlistContainer = () => {
  return (
    <>
      <Card>
        <Card.Header className="bg-transparent">
          <Card.Title className="p-t-8 p-b-2">Favorit</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row gutter={[14, 14]}>
            <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
              <Input prefix={<SearchOutlined />} placeholder="Cari di favorit" />
            </Col>
            <Col xxl={12} lg={12} md={12} sm={24} xs={24}>
              <Select placeholder="Urutkan" className="w-100">
                <Select.Option value="Terbaru">Terbaru</Select.Option>
                <Select.Option value="Terlama">Terlama</Select.Option>
                <Select.Option value="Harga Tertinggi">Harga Tertinggi</Select.Option>
                <Select.Option value="Harga Terendah">Harga Terendah</Select.Option>
              </Select>
            </Col>
          </Row>
          <br />

          <Row gutter={[14, 14]}>
            {productLists.map((product) => (
              <Col xxl={4} xl={6} lg={6} md={6} sm={8} xs={12} key={product.name}>
                <CardProduct product={product} />
              </Col>
            ))}
          </Row>

          <Row gutter={[14, 14]} className="mt-4 mb-2">
            <Col span={24}>
              <Pagination
                total={60}
                current={1}
                pageSize={10}
                hideOnSinglePage
                className="text-center"
                goTo={() => {}}
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default WishlistContainer;
